import React from "react";

const ErrorsTable = ({ theme, language, errors = [] }) => {
  if (!errors || errors.length === 0) return null;

  const isAr = language === "ar";

  const thStyle = {
    padding: "10px 14px",
    textAlign: "center",
    fontSize: "11px",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    background:
      theme === "dark"
        ? "rgba(239, 68, 68, 0.2)"
        : "rgba(254, 226, 226, 0.8)",
    color: theme === "dark" ? "#fca5a5" : "#b91c1c",
    borderBottom:
      theme === "dark"
        ? "2px solid rgba(239, 68, 68, 0.3)"
        : "2px solid rgba(239, 68, 68, 0.2)",
    whiteSpace: "nowrap",
  };

  const tdStyle = {
    padding: "10px 14px",
    fontSize: "12px",
    textAlign: "center",
    color: theme === "dark" ? "rgba(255,255,255,0.8)" : "#475569",
    borderBottom:
      theme === "dark"
        ? "1px solid rgba(239, 68, 68, 0.1)"
        : "1px solid rgba(239, 68, 68, 0.08)",
  };

  return (
    <div style={{ marginTop: "16px" }}>
      <h4
        style={{
          margin: "0 0 10px 0",
          fontSize: "13px",
          fontWeight: "700",
          color: theme === "dark" ? "#fca5a5" : "#b91c1c",
        }}
      >
        {isAr ? `أخطاء (${errors.length})` : `Errors (${errors.length})`}
      </h4>
      <div style={{ overflowX: "auto", borderRadius: "10px" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "separate",
            borderSpacing: 0,
            minWidth: "500px",
          }}
        >
          <thead>
            <tr>
              <th style={thStyle}>{isAr ? "الصف" : "Row"}</th>
              <th style={thStyle}>{isAr ? "كود العميل" : "Client Code"}</th>
              <th style={thStyle}>{isAr ? "التاريخ" : "Date"}</th>
              <th style={thStyle}>{isAr ? "الخطأ" : "Error"}</th>
            </tr>
          </thead>
          <tbody>
            {errors.map((err, idx) => (
              <tr key={idx}>
                <td style={tdStyle}>{err.row ?? idx + 1}</td>
                <td style={tdStyle}>{err.clientCode || err.employeeId || "-"}</td>
                <td style={tdStyle}>{err.date || "-"}</td>
                <td
                  style={{
                    ...tdStyle,
                    color: theme === "dark" ? "#fca5a5" : "#dc2626",
                    fontWeight: "500",
                    textAlign: "left",
                  }}
                >
                  {err.error || err.message || "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ErrorsTable;